var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome03 = function SvgHome03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 20.885V10.759l-1.868 1.433-.902-1.196L3.5 8.87V6H5v1.72L12 2l11.269 8.996-.902 1.181-1.867-1.418v10.126zm1.5-1.5h5.808V15h2.384v4.385H19V9.619L12 3.91 5 9.62z"
  })));
};
export default SvgHome03;